<template>
    <div class="is-clickable" v-if="travelPolicy" ref="tagWrapper" @mouseenter="toggleTooltip"
    @mouseleave="hideTooltip" style="max-width: fit-content;">
      <div
        v-if="travelPolicy.summary.rulesTriggeredCount > 0"
        ref="tagContent"
        style="width:max-content"
      >
        <div>
          <b-icon
            v-if="isShort"
            :type="tagType"
            icon="alert"
            size="is-default"
            class=""
          ></b-icon>

          <b-tag v-else :type="tagType" class="">
            <b-icon
              :icon="
                travelPolicy.summary.mostStrictApprovalRequired == 'soft'
                  ? 'alert'
                  : 'alert-octagon'
              "
              size="is-small"
            ></b-icon>
            <span>Out of Policy </span>
          </b-tag>
        </div>
      </div>

      <div
        ref="tooltipContent"
        class="popper-popup has-padding-3 card p-3 m-1"
        style="border: 1px solid rgb(221, 217, 217); max-width:80%;background-color: whitesmoke"
      >
        <h5 class="is-size-7 has-text-weight-bold has-text-left mb-1">
          {{ summaryHeading }}
        </h5>
        <ul class="has-text-left">
          <li
            class="is-size-7"
            v-for="item in travelPolicy.rulesTriggered"
            :key="item.message"
          >
            {{ item.message }}
          </li>
        </ul>
      </div>


      
    </div>
</template>

<script>
export default {
  name: "OutOfPolicyTag",
  props: {
    travelPolicy: Object,
    position: {
      type: String,
      default: "is-bottom",
    },
    isShort: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tooltipTimeout: null,
      // active: false,
    }
  },
  mounted() {},
  methods: {
    toggleTooltip() {
      // Clear any existing timeout
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout)
      }

      // Set new timeout
      this.tooltipTimeout = setTimeout(() => {
        this.$popper.togglePopper(
          this.$refs.tagWrapper,
          this.$refs.tooltipContent
        )
      }, 100)
    },

    hideTooltip() {
      // Clear timeout if it exists
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout)
        this.tooltipTimeout = null
      }

      // Hide tooltip immediately
      this.$popper.hidePopper(
        this.$refs.tagWrapper,
        this.$refs.tooltipContent
      )
    },
  },
  computed: {
    summaryHeading() {
      let heading = "Summary"

      if (this.travelPolicy.summary.mostStrictApprovalRequired == "soft") {
        heading = "Triggers Manager Notification"
      } else if (
        this.travelPolicy.summary.mostStrictApprovalRequired == "hard"
      ) {
        heading = "Requires Manager Approval"
      } else if (
        this.travelPolicy.summary.mostStrictApprovalRequired == "none"
      ) {
        heading = "Trip Will Be Logged for Reporting"
      } else if (this.travelPolicy.summary.visibility == "unselectable") {
        heading = "Not Allowed to Book"
      } else if (this.travelPolicy.summary.visibility == "hide") {
        heading = "Result Hidden"
      }

      return heading
    },
    tagType() {
      let tagType = "is-light"

      if (this.travelPolicy.summary.mostStrictApprovalRequired == "soft") {
        tagType = "is-warning"
      } else if (
        this.travelPolicy.summary.mostStrictApprovalRequired == "hard"
      ) {
        tagType = "is-danger"
      }

      return tagType
    },
  },
}
</script>

<style scoped></style>
